import './App.css';
import { BrowserRouter as Router, useRoutes } from 'react-router-dom';
import Sidebar from './Components/Sidebar/Sidebar';
import './Assets/customStyles/CustomStyle.css';
import { routesArr } from './routes';
import { Drawer } from 'antd';
import { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { GetArticleAction } from './module/action/Articles';
import { getAllBookAction } from './module/action/Book';
import DrawerIcon from './Assets/Icons/DrawerIcon';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getCookie } from './api/utils';

const AppRoutes = () => {
  let routesCust = routesArr.map((a, i) => {
    return {
      path: a.route,
      element: a.component,
    };
  });
  let routes = useRoutes(routesCust);
  return routes;
};

function App() {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  let token = getCookie('token');

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    dispatch(GetArticleAction());
    dispatch(getAllBookAction());
  }, []);

  return (
    <Router>
      <ToastContainer />
      <div className="flex dashboardMain relative">
        <div className="hidden xl:block h-[100vh] sticky top-0 ">
          <Sidebar />
        </div>
        <button className="drawerButton" onClick={showDrawer}>
          <DrawerIcon />
        </button>
        <div className={!token ? ' w-full' : 'dashboard'}>
          <AppRoutes />
        </div>
      </div>
      <Drawer placement="left" onClose={onClose} open={open}>
        <Sidebar />
      </Drawer>
    </Router>
  );
}

export default App;
